module.exports = __webpack_public_path__ + "img/event-inactive-marker.e947e4c6.svg";